import { Clear, Create, Done, LocationOn, Search } from "@mui/icons-material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"
import { useState, useContext, useEffect } from "react"
import ConfirmModal from "../../../Components/ConfirmModal/ConfirmModal"
import OneButton from "../../../Components/OneButton/OneButton"
import OneInput from "../../../Components/OneInput/OneInput"
import OneTable from "../../../Components/OneTable/OneTable"
import { WebSocketContext } from "../../../Providers/WebSocket/WebSocketContext"
import { filtroTextoPesquisa, getMapLink, showNotify } from "../../../Utils/Utils"
import { CadastroCondominio } from "./CadastroCondominio/CadastroCondominio"

const CondominiosConfig = () => {
    const [openCadastro, setOpenCadastro] = useState(false)
    const [idToEdit, setIdToEdit] = useState(0)
    const [idCentral, setIdCentral] = useState(0)
    const [tipoCondominio, setTipoCondominio] = useState(0)

    const tableColumns = [
        {
            name: 'Conta',
            selector: row => row.id_central
        },
        {
            name: 'Condomínio / Empresa',
            selector: row => row.nome,
            grow: 20
        },
        {
            name: 'Tipo',
            selector: row => row.nome_tipo_condominio ? row.nome_tipo_condominio : <span style={{ color: 'red' }} >Sem tipo</span>,
            grow: 3
        },
        {
            name: 'Equipe',
            selector: row => row.nome_id_equipe ? row.nome_id_equipe : "Qualquer equipe",
            grow: 5
        },
        {
            name: 'Maps',
            selector: row => row.endereco
                ? <a target="_blank" href={`${getMapLink(row.endereco)}`} rel="noreferrer" style={{ textDecoration: 'none' }}>
                    <LocationOn sx={{ color: '#0fab22' }} />
                </a>
                : <LocationOn sx={{ color: 'grey' }}/>
        },
        {
            name: 'Ativo',
            selector: row => row.online ? <Done sx={{ color: "green" }} /> : <Clear sx={{ color: "red" }}/>
        },
        {
            name: 'Editar',
            cell: (row) => <Create sx={{ cursor: 'pointer' }} onClick={() => { editCondominio(row) }}/>,
            button: true
        }
        // {
        //     name: 'Excluir',
        //     cell: (row) => <Delete sx={{ cursor: 'pointer', color: 'red' }} onClick={() => { setDeleteIdTag(row.id); setConfirmDelete(true) }}/>,
        //     button: true
        // }
    ]

    const { sendWs, addRoute } = useContext(WebSocketContext)

    const [filterText, setFilterText] = useState('')
    const [textToSearch, setTextToSearch] = useState('')
    const [loading, setLoading] = useState(false)
    const [condominiosList, setCondominiosList] = useState(false)
    const filteredDataList = filtroTextoPesquisa(condominiosList, filterText, ['nome', 'id_central'])

    const [confirmDelete, setConfirmDelete] = useState(false)
    const [deleteIdCondominio, setDeleteIdCondominio] = useState(null)

    const handleSearch = (event) => {
        event.preventDefault()
        setFilterText(textToSearch)
    }

    const handleChange = (event) => {
        setTextToSearch(event.target.value)
    }

    const getWsResponse = (msg) => {
        setCondominiosList(msg.data.condominios)
        setLoading(true)
    }

    useEffect(() => {
        addRoute("buscarTodosCondominios", getWsResponse)
        sendWs("buscarTodosCondominios")
    }, [])

    const editCondominio = (condominio) => {
        setIdToEdit(condominio.id)
        setIdCentral(condominio.id_central)
        setTipoCondominio(condominio.tipo_condominio)
        setOpenCadastro(true)
    }

    const getDeleteResponse = (msg) => {
        if (msg.data.status) {
            showNotify("success", "Condominio deletado com sucesso")
            sendWs("buscarTodosCondominios")
            setConfirmDelete(false)
            setDeleteIdCondominio(null)
        } else {
            showNotify("error", msg.data.message)
            setConfirmDelete(false)
        }
    }

    const deleteCondominio = () => {
        addRoute("deleteCondominio", getDeleteResponse)
        sendWs("deleteCondominio", { id: deleteIdCondominio })
    }

    return (
        <Grid xs={12} sx={{ width: '100%', height: '100%', display: 'flex', flexFlow: 'column' }} flexDirection="column" rowGap={1}>
            {openCadastro &&
            <CadastroCondominio
                openCadastro={openCadastro}
                setOpenCadastro={setOpenCadastro}
                idCentral={idCentral}
                setIdCentral={setIdCentral}
                idToEdit={idToEdit}
                setIdToEdit={setIdToEdit}
                tipoCondominio={tipoCondominio}
            />
            }
            {confirmDelete &&
                <ConfirmModal
                    titleText="Deletar Texto de Condominio"
                    open={confirmDelete}
                    text="Você deseja deletar o texto de Fechamento?"
                    setOpen={setConfirmDelete}
                    cancelFunction={() => setConfirmDelete(false)}
                    confirmFunction={deleteCondominio}
                />
            }
            <Grid container xs={12} sx={{ alignItems: 'center', height: '50px' }}>
                <Grid xs={12} sm={6}>
                    <form
                        onSubmit={handleSearch}
                    >
                        <Grid container columnGap={1} xs={12} sx={{ alignItems: 'center' }}>
                            <Grid xs={6} sm={7.5}>
                                <OneInput name="pesquisar" onChange={handleChange} />
                            </Grid>
                            <Grid xs={4} sm={4}>
                                <OneButton
                                    id="button_teste"
                                    color="one_primary"
                                    variant="contained"
                                    type="submit"
                                    IconStart={Search}
                                >
                                     Pesquisar
                                </OneButton>
                            </Grid>
                        </Grid>
                    </form>
                </Grid>
                <Grid xs={6} sx={{ alignItems: 'center' }}>
                    <Grid container justifyContent="flex-end">
                        {/* <Button
                            id="button_teste"
                            color="one_primary"
                            variant="contained"
                            onClick={() => { setIdToEdit(null); setOpenCadastro(true) }}
                            sx={{ width: '148px', height: '30px' }}
                        >
                            <AddCircle sx={{ marginRight: '7px' }} />
                            Novo
                        </Button> */}
                    </Grid>
                </Grid>
            </Grid>

            <Grid container xs={12} sx={{
                backgroundColor: '#D9D9D9',
                borderRadius: '5px',
                display: 'flex',
                flexGrow: 1,
                flexBasis: 'auto'
            }}>
                {condominiosList &&
                <OneTable
                    columns={tableColumns}
                    data={filteredDataList}
                    progressPending={!loading}
                    dobleClickCallback={editCondominio}
                    extraCallbackParams={true}
                />
                }
            </Grid>
        </Grid>
    )
}

export default CondominiosConfig
